import React from 'react';
import PropTypes from 'prop-types';
import classNames, { classNamesFor } from '../../utils/classNames';
import ServiceIcon from '../ServiceIcon';
import AlignToText from '../../AlignToText';
/**
 * Renders any of a variety of views associated with the "service upsell"
 * (or just "upsell") region of a product tile, each of which includes a
 * service icon and a short text "descriptor."
 *
 * The component name is for convenience and should not be taken too literally.
 * The descriptor text does not necessarily attempt to "upsell" and may present
 * "social proof" or information of another kind.
 *
 * For visual examples, see "ServiceUpsell" within Storybook or see the legacy
 * Product Tile design at https://atlas.np.tools.playstation.net/design/f641f67c-066b-4a6d-9eac-0cdb5198d5bb/45?bounds=0.384,1.671,0.477,0.354&rev=45,45&x=1314.70,1373.04&y=6433.77,5390.05
 */

var ServiceUpsell = function ServiceUpsell(_ref) {
  var className = _ref.className,
      qa = _ref.qa,
      serviceType = _ref.serviceType,
      descriptorText = _ref.descriptorText,
      variant = _ref.variant,
      disabled = _ref.disabled;

  var _ServiceUpsell$getCla = ServiceUpsell.getClassName({
    className: className,
    serviceType: serviceType,
    variant: variant,
    disabled: disabled
  }),
      root = _ServiceUpsell$getCla.root,
      contentsClass = _ServiceUpsell$getCla.contents,
      textClass = _ServiceUpsell$getCla.descriptorText;

  if (!serviceType || serviceType === 'NONE' || !descriptorText) return null;
  return /*#__PURE__*/React.createElement("div", {
    "data-qa": qa,
    className: root
  }, /*#__PURE__*/React.createElement("div", {
    className: contentsClass
  }, /*#__PURE__*/React.createElement(AlignToText, {
    fontStyle: variant === 'tag' ? 'tag' : 'overline'
  }, /*#__PURE__*/React.createElement(ServiceIcon, {
    qa: "".concat(qa, "#service-icon"),
    className: classNames('psw-m-r-1', disabled && 'psw-dimmed'),
    serviceType: serviceType
  })), /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#descriptorText"),
    className: textClass
  }, descriptorText)));
};

var cx = classNamesFor(ServiceUpsell);

ServiceUpsell.getClassName = function (_ref2) {
  var className = _ref2.className,
      serviceType = _ref2.serviceType,
      variant = _ref2.variant,
      disabled = _ref2.disabled;
  return {
    root: cx(className, 'psw-service-upsell', variant === 'tag' && cx('psw-t-tag', 'psw-p-l-1', 'psw-p-r-2', 'psw-platform-tag'), disabled && 'psw-is-disabled'),
    contents: cx('psw-service-upsell__contents', 'psw-t-align-c', 'psw-l-line-left', variant !== 'tag' && 'psw-t-overline'),
    descriptorText: cx('psw-truncate-text-1', !disabled && serviceType === 'PS_PLUS' ? 'psw-c-t-ps-plus' : "psw-c-t-".concat(variant === 'tag' ? '1' : '2'), disabled && 'psw-c-t-disabled')
  };
};

ServiceUpsell.defaultProps = {
  className: '',
  qa: '',
  variant: 'standard',
  disabled: false
};
ServiceUpsell.propTypes = {
  className: PropTypes.string,
  qa: PropTypes.string,
  serviceType: PropTypes.string.isRequired,
  descriptorText: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['standard', 'tag']),
  disabled: PropTypes.bool
};
export default ServiceUpsell;